"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var brazilian_values_1 = require("brazilian-values");
var unmask_1 = require("../utils/unmask");
var regex = /([0-9]{2}[.]?[0-9]{3}[.]?[0-9]{3}[/]?[0-9]{4}[-]?[0-9]{2})|([0-9]{3}[.]?[0-9]{3}[.]?[0-9]{3}[-]?[0-9]{2})/;
var isValid = function (value) {
    var unmaskValue = (0, unmask_1.unmask)(value);
    if (unmaskValue.length !== 14 || !regex.test(unmaskValue)) {
        return false;
    }
    return (0, brazilian_values_1.isCNPJ)(value);
};
var validateCnpj = function (value) {
    return isValid(value) ? false : 'CNPJ inválido';
};
exports.default = validateCnpj;
//# sourceMappingURL=cnpj.js.map